import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Actions", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Upload designs ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Edit mode ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  Upload ")
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Edit code ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Edit deisgn ")
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { key: 6 }
const _hoisted_17 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_PreviewImage = _resolveComponent("PreviewImage")!
  const _component_ChooseCatalogCode = _resolveComponent("ChooseCatalogCode")!
  const _component_UploadArtworksDialog = _resolveComponent("UploadArtworksDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", null, [
                (_ctx.state.multipleSelection.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, { style: {"width":"188px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_dropdown_item, { onClick: _ctx.uploadDesigns }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { type: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.state.multipleSelection.length) + " " + _toDisplayString(_ctx.state.multipleSelection.length > 1 ? 'selecteds' : 'selected') + " ", 1),
                            _createVNode(_component_el_divider, { direction: "vertical" }),
                            _hoisted_2,
                            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_arrow_down)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.state.isEditMode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.isEditMode) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.isEditMode === !_ctx.state.isEditMode))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _ctx.state.variants,
      stripe: "",
      fit: "",
      style: {"width":"100%"},
      "max-height": "600px",
      lazy: "",
      onSelectionChange: _ctx.onSelectVariants,
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          "min-width": "2"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: column.dataIndex,
            prop: column.dataIndex,
            label: column.title,
            "tooltip-effect": column.dataIndex,
            "min-width": column.minWidth,
            align: column.align,
            sortable: column.sort
          }, {
            default: _withCtx((scope) => [
              (column.title === 'Artworks')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ARTWORK_SPACES, (artworkSpace) => {
                      return (_openBlock(), _createElementBlock("span", { key: artworkSpace }, [
                        (scope.row[artworkSpace])
                          ? (_openBlock(), _createBlock(_component_el_image, {
                              key: 0,
                              src: _ctx.imageUrl(scope.row[artworkSpace], true, 200),
                              onClick: ($event: any) => (_ctx.onClickPreviewImage(_ctx.imageUrl(scope.row[artworkSpace]))),
                              style: {"width":"80px","height":"80px"},
                              fit: "cover"
                            }, {
                              error: _withCtx(() => [
                                _createVNode(_component_slot_error)
                              ]),
                              _: 2
                            }, 1032, ["src", "onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (column.title === 'Artwork')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (
              scope.row[column.dataIndex]?.length > 0 &&
              scope.row[column.dataIndex][0]?.catalogVariants?.length > 0 &&
              scope.row[column.dataIndex][0]?.catalogVariants[0]?.designQty > 0
            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_el_button, {
                              onClick: ($event: any) => (_ctx.uploadArtwork([scope.row])),
                              type: "primary",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                _hoisted_9
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (column.title === 'Actions')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_el_link, {
                          type: "primary",
                          plain: "",
                          title: "Edit code",
                          onClick: ($event: any) => (_ctx.onChangeCatalogCode(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          type: "primary",
                          title: "Edit deisgn",
                          plain: "",
                          onClick: ($event: any) => (_ctx.onUploadArtworksDialog(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : (_ctx.state.isEditMode && column.dataIndex === 'title')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_el_input, {
                            modelValue: scope.row.title,
                            "onUpdate:modelValue": ($event: any) => ((scope.row.title) = $event),
                            size: "small",
                            clearable: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      : (_ctx.state.isEditMode && column.dataIndex === 'option1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_el_input, {
                              modelValue: scope.row.option1,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.option1) = $event),
                              size: "small",
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]))
                        : (_ctx.state.isEditMode && column.dataIndex === 'option2')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_el_input, {
                                modelValue: scope.row.option2,
                                "onUpdate:modelValue": ($event: any) => ((scope.row.option2) = $event),
                                size: "small",
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          : (_ctx.state.isEditMode && column.dataIndex === 'option3')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(_component_el_input, {
                                  modelValue: scope.row.option3,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.option3) = $event),
                                  size: "small",
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(scope.row[column.dataIndex]), 1))
            ]),
            _: 2
          }, 1032, ["prop", "label", "tooltip-effect", "min-width", "align", "sortable"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data", "onSelectionChange"]),
    _createVNode(_component_PreviewImage, { ref: "previewImageDialog" }, null, 512),
    _createVNode(_component_ChooseCatalogCode, {
      ref: "changeCatalogCodeDialog",
      onCallbackChangeVariantCode: _ctx.callbackChangeVariantCode
    }, null, 8, ["onCallbackChangeVariantCode"]),
    _createVNode(_component_UploadArtworksDialog, {
      ref: "uploadArtworksDialog",
      onCallbackUploadArtworks: _ctx.callbackUploadArtworks
    }, null, 8, ["onCallbackUploadArtworks"])
  ], 64))
}